import { createAction } from "typesafe-actions";
import type { EWalkThroughSteps } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";

const WALK_THROUGH = "walkThrough";

export const setWalkThrough = createAction(`@@si/${WALK_THROUGH}/SET_FULL_WALK_THROUGH`)<{
    isOpen: boolean;
    step: EWalkThroughSteps;
}>();

export const setWalkThroughIsOpen = createAction(`@@si/${WALK_THROUGH}/SET_IS_OPEN_WALK_THROUGH`)<boolean>();
